module.exports = __webpack_public_path__ + "static/media/sample-banner.1d95c17f.jpg";